import { siteConfig } from '@/config/site';
import { apiBaseForBrowser } from './loopbackUrl';

/** API base for browser fetch — never loopback on HTTPS (avoids Chrome "Apps on device" prompt). */
export function resolvedApiBaseUrl(): string {
  return apiBaseForBrowser(siteConfig.apiBaseUrl);
}

/** Ops auth API (OTP / recaptcha). Empty → same-origin community API (paydirt / ops console). */
export function resolvedAuthApiBaseUrl(): string {
  const auth = process.env.NEXT_PUBLIC_AUTH_API_URL?.trim();
  if (auth) return apiBaseForBrowser(auth.replace(/\/$/, ''));
  return resolvedApiBaseUrl();
}
